/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import AccordionComponent from '../Interactives/accordion/accordion';
import ButtonComponent from '../Interactives/button';
import TabComponent from '../Interactives/tabs';
import ClickAndRevealComponent from '../Interactives/clickAndReveal';
import FlipCard from '../Interactives/flipCard/flipCardPreview';
import ImageSlider from '../Interactives/imageSlider';
import HotspotViewComponent from '../Interactives/hotspot/hotspotView';
import DragAndDropComponent from '../Interactives/draganddrop';
import MCQComponent from '../Interactives/multipleChoice';
import ModalComponent from '../utils/modal';
import { insertBrInEmptyBlocks } from './utils';
import ChecklistComponent from '../Interactives/checklist';

const getPreviewComponent = (type: string, content: any, buttonParameter: {}) => {
  const parameters = insertBrInEmptyBlocks(content.parameters, type);
  switch (type) {
    case 'Accordion':
      return <AccordionComponent parameters={parameters} customisations={content} isLMSView />;
    case 'Tabs':
      return <TabComponent parameters={parameters} customisations={content} />;
    case 'Button':
      return <ButtonComponent parameters={buttonParameter} customisations={content} />;
    case 'multiplechoice':
      return (
        <MCQComponent
          parameters={parameters}
          customisations={{
            ...content,
            checkAnswer: content.checkedAnswer,
            optionType: content.optiontype,
            retry: content.customtryagain,
          }}
        />
      );
    case 'ClickAndRevealInteractions':
      return <ClickAndRevealComponent parameters={parameters} customisations={content} />;
    case 'flipcard':
      return <FlipCard parameters={parameters} customisations={content} />;
    case 'imageslider':
      return <ImageSlider parameters={parameters} customisations={content} />;
    case 'Hotspot':
      return <HotspotViewComponent parameters={content.dndParameters} customisations={content} />;
    case 'DragandDrop':
      return (
        <DragAndDropComponent
          parameters={content.dndLayout === 'CustomOverlay' ? content.dndParameters : parameters}
          customisations={content}
        />
      );
    case 'checklist':
      return <ChecklistComponent parameters={buttonParameter} customisations={content} />;
    default:
      return <></>;
  }
};

const PreviewComponent = (props: any) => {
  const [buttonParameter, setButtonParamaeter] = useState({});
  const [customisation, setCustomisation] = useState({});

  const { content, type } = props;
  useEffect(() => {
    if (type === 'Button') {
      const { name, link, isChecked } = content;

      setButtonParamaeter({
        name,
        link,
        isChecked,
      });

      const customData = { ...content };
      customData.bgColor = content.color;
      setCustomisation(customData);
    } else if (type === 'checklist') {
      const { checklistItems, title, name } = content;
      setButtonParamaeter({
        checklistItems,
        title,
        name,
      });

      const customData = { ...content };
      customData.bgColor = content.color;
      setCustomisation(customData);
    }
  }, [props.show, content, type, props.parameters]);
  return (
    <ModalComponent
      size='xl'
      show={props.show}
      handleCancel={props.onHide}
      modalDetails={{
        title: 'Preview',
        body: getPreviewComponent(
          type,
          type === 'Button' || type === 'checklist' ? customisation : content,
          buttonParameter,
        ),
      }}
      modalType='preview'
    />
  );
};

export default PreviewComponent;
